import { useToast, useTranslations } from "@jugl-web/utils";
import { InvoiceModel, UpdateInvoicePayload } from "@jugl-web/rest-api";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { invoicesApi } from "@web-src/features/api/createApi";

export const useUpdateInvoice = () => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const [updateInvoiceMutation] = invoicesApi.useUpdateInvoiceMutation();
  const { toast } = useToast();

  return async (
    invoiceId: string,
    payload: Partial<UpdateInvoicePayload>
  ): Promise<InvoiceModel> => {
    try {
      const updatedInvoice = await updateInvoiceMutation({
        entityId,
        invoiceId,
        payload,
      }).unwrap();

      toast(
        t({
          defaultMessage: "Invoice updated successfully",
          id: "invoices.invoice-updated-successfully",
        }),
        {
          variant: "success",
        }
      );

      return updatedInvoice;
    } catch (error) {
      toast(
        t({
          defaultMessage: "Failed to update invoice",
          id: "invoices.invoice-update-failed",
        }),
        {
          variant: "error",
        }
      );
      throw error;
    }
  };
};
